import React from 'react'

import { type PaperSizes } from '../Paper'

import './Repel.css'

type RepelProps = {
  wrap?: 'wrap' | 'nowrap'
  align?: 'baseline' | 'center' | 'end' | 'start'
  gap: ArrayElement<typeof PaperSizes>
  children: React.ReactNode
}

const Repel = ({ wrap, align, gap, children }: RepelProps): JSX.Element => (
  <div
    className="Repel"
    style={{
      // @ts-expect-error: the custom properties are valid properties for the style object
      '--repel-wrap': wrap,
      '--repel-vertical-alignment': align,
      '--repel-gap': gap ? `${gap}px` : null,
    }}
  >
    {children}
  </div>
)

export { Repel }
